/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Logs/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Content from './Content/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'



/** @type {import('Simple/types.js').View} */
export default function Logs({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main/TasksList/Content/Content/CommentsLogs/Logs",
  closePopover
  
}) {
  let isBefore = useIsBefore()
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<div
  data-testid="Logs.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-as1A': dtColorsNeutral200,'--bc-2-as1A': dtColorsWhite,'--btlr-3-as1A': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-4-as1A': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-5-as1A': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-6-as1A': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-7-as1A': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--o-8-as1A': isBefore ? 0 : 1,'--ty-9-as1A': isBefore ? "-8px" : "0px"}}
 className={`views-block new-shadow ${styles.Vertical}`}
>
<div
  data-testid="Logs.Vertical:1"
  data-view-path={viewPath}
 closePopover={closePopover}
 className="views-block"
>
<div
  data-testid="Logs.Vertical:2"
  data-view-path={viewPath}
 style={{'--ml-10-as1A': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mr-11-as1A': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mb-12-as1A': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Task Log"
 weight="semibold"
 color={dtColorsNeutral500}
/>
</div>
<Content
  viewPath={`${viewPath}/Content`}
/>
</div>
</div>
{children}
</React.Fragment>)
}